<div mat-dialog-title>
  <div i18n>Фрезеровка</div>
  <button mat-icon-button [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="no-padding">
  <table class="w-full" mat-table #table [dataSource]="data.millings">
    <ng-container matColumnDef="selection">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          data-testid="millingsSelectionCheckbox"
          [checked]="selection.isSelected(row)"
          (change)="selection.select(row)"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <csl-texture-viewer
          [cropTextureLink]="getIconLink(row.id)"
          [textureLink]="getIconLink(row.id)"
          [imageFit]="'scale-down'"></csl-texture-viewer>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef i18n>Название</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef i18n>Описание</th>
      <td mat-cell *matCellDef="let row">{{ row.description }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    [disabled]="!selection.selected.length"
    [mat-dialog-close]="selection.selected"
    data-testid="millingsSaveButton"
    color="accent"
    i18n
    >Добавить</button
  >
  <button cdkFocusInitial mat-button [mat-dialog-close] i18n>Отмена</button>
</div>
